
import { BasicDialogHandler } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2LevelUpAnimDialog } from "../../../view/dialogs/animdialog/Poker2LevelUpAnimDialog";
import { Poker2LevelUpAnimDialogProperties } from "../../../view/dialogs/animdialog/Poker2LevelUpAnimDialogProperties";
import { Poker2Command } from "../Poker2Command";

export class LVUCommand extends Poker2Command {
    protected get cmdId(): string {
        return "lvu";
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);
            var chips: number = paramObj.chips;
            var gold: number = paramObj.gold;
            BasicDialogHandler.getInstance().registerDialogs("Poker2LevelUpAnimDialog", new Poker2LevelUpAnimDialogProperties(chips, gold), true, BasicDialogHandler.PRIORITY_MIDDLE);
        }
        return (error == 0);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
